import { render } from "./TelemedicineContentPtBR.vue?vue&type=template&id=195d9c32"
import script from "./TelemedicineContentPtBR.vue?vue&type=script&lang=js"
export * from "./TelemedicineContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__